import React, { useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { revertBill } from 'screens/Orders/actions';

const RevertButton = styled.button`
	background: transparent;
	border: 1px solid var(--restrictions-border, currentColor);
	border-radius: 4px;
	color: var(--restrictions-text, inherit);
	cursor: pointer;
	font: inherit;
	height: 24px;
	padding: 0 10px;
	text-transform: uppercase;

	&:focus-visible {
		outline: 2px solid var(--restrictions-accent, currentColor);
		outline-offset: 2px;
	}

	&:disabled {
		cursor: not-allowed;
		opacity: 0.55;
	}
`;

export default function BillingRevertAction({ orderId, onChanged }) {
	const [submitting, setSubmitting] = useState(false);
	const submittingRef = useRef(false);
	const dispatch = useDispatch();

	if (!orderId) return null;

	const handleRevert = () => {
		if (submittingRef.current) return;
		submittingRef.current = true;
		setSubmitting(true);
		const finish = function* (changed) {
			submittingRef.current = false;
			setSubmitting(false);
			if (changed && onChanged) yield onChanged();
		};

		dispatch(
			revertBill(orderId, {
				onSuccess: function* () {
					yield finish(true);
				},
				onError: function* () {
					yield finish(false);
				},
			}),
		);
	};

	return (
		<RevertButton
			type='button'
			disabled={submitting}
			onClick={handleRevert}
			aria-label='Revertir facturación de la orden'
		>
			Revertir
		</RevertButton>
	);
}
